import { api } from "../../../api";
import {
  CargoPackagingProps,
  CargoPackagingResponse,
  RequestWmsParams,
} from "../types";

export async function getWmsListApi(
  params: RequestWmsParams,
): Promise<CargoPackagingResponse> {
  const { data } = await api.get<CargoPackagingResponse>(`/api/packing-lists`, {
    params,
  });
  return data;
}

export async function exportLiteWmsApi(
  params?: Partial<RequestWmsParams>,
): Promise<{
  file: Blob;
  filename: string;
}> {
  const response = await api.get(`/api/packing-lists/export`, {
    params,
    responseType: "blob",
  });
  const disposition = response.headers["content-disposition"];
  let filename = "downloaded_file";
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = decodeURIComponent(match[1]);
    }
  }

  return { file: response.data, filename };
}

export async function updatePackingListApi(
  id: number,
  params: Partial<CargoPackagingProps>,
): Promise<Partial<CargoPackagingProps>> {
  const { data } = await api.patch<Partial<CargoPackagingProps>>(
    `/api/packing-lists/${id}`,
    params,
  );
  return data;
}
